<template>
  <div v-if="isDispatch">
    <h3 class="om-page-heading">
      {{ isReturn() ? $tr('Zwrot zamówienia', 'Order') : '' }}
      {{ isCollect() ? $tr('Odbiór zamówienia', 'Order') : '' }}
      <router-link :to="{ name: `${this.$route.name}List` }" class="om-link-back">
        <i class="om-ico-back-link" aria-hidden="true"></i>
        {{ $tr('wróć', 'Order') }}
      </router-link>
    </h3>
    <div v-if="order" class="om-order">
      <ul class="om-order__general">
        <li>
          <span class="om-order__lab">{{ $tr('Zamówienie:', 'Order') }}</span> {{ order.reference }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Imię i nazwisko:', 'Order') }}</span> {{ order.firstname + ' ' + order.lastname }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Telefon:', 'Order') }}</span> {{ order.phone }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Adres e-mail:', 'Order') }}</span> {{ order.email }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Nr konta bankowego:', 'Order') }}</span>
          <transition name="fade">
            <span v-if="!editFlags.account_number">
              <span>{{ order.account_number }}</span>
              <span class="om-small-action" @click="editFlags.account_number = !editFlags.account_number">
                {{ $tr('edytuj', 'Order') }}
              </span>
            </span>

            <span v-if="editFlags.account_number">
              <input type="text" class="om-input om-input--inline" v-model="order.account_number" :size="order.account_number ? order.account_number.length : 1" :title="$tr('Nr konta bankowego', 'Order')"/>
              &nbsp;
              <button class="om-btn om-btn--inline" @click.prevent="updateCustomer({account_number: order.account_number})">{{ $tr('zapisz', 'Order') }}</button>
            </span>
          </transition>


        </li>
      </ul>

      <div v-if="order.products" class="om-products">
        <table class="om-table">
          <thead>
            <tr>
              <th>{{ $tr('Produkty', 'Order') }} ({{ order.products.length }})</th>
              <th>{{ $tr('Cena jednostkowa (brutto)', 'Order') }}</th>
              <th>{{ $tr('Ilość', 'Order') }}</th>
              <th v-if="isReturn()" class="om-text-center">{{ $tr('Informacje o zwrocie', 'Order') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(p, key) in order.products"
              :key="key">
              <td>
                <div class="flex cen">
                  <div class="om-products__image">
                    <img :src="p.image" :alt="p.name"/>
                  </div>
                  <div class="om-products__desc fg-20">
                    <h4 class="om-products__medium">{{ p.name }}</h4>
                    <h5 class="om-products__small">{{ $tr('Kod produktu:', 'Order') }} {{ p.reference }}</h5>
                    <ul v-if="p.attributes" class="om-attributes">
                      <li v-for="(val, attr) in p.attributes" class="om-products__small" :key="attr">
                        {{ attr }}: {{ val }}
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
              <td class="om-std">{{ p.price }} <span class="currency">{{ p.currency }}</span></td>
              <td class="om-std">{{ p.quantity }}</td>
              <td v-if="isReturn() && key === 0" :rowspan="order.products.length" class="om-std om-text-center">
                <div class="font-normal">{{ $moment(order.date_return).format('DD.MM.YYYY') }}{{ $tr('r.', 'Order') }}</div>
                <div class="font-normal">{{ $tr('godz.', 'Order') }} {{ $moment(order.date_return).format('HH:mm') }}</div>
                <div class="font-normal">{{ order.store_return.name }}</div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
      <span class="om-vertical-space"></span>
      <div v-if="isCollect()">
        <section v-if="collect_store" class="om-section">
          <h3 class="om-subheading">
            {{ $tr('Adres odbioru', 'Order') }}
          </h3>
          <div class="om-text-sc">
            <div>{{ collect_store.name }}</div>
            <div>
              {{ $tr('ul.', 'ShopList') }} {{ collect_store.address.street }}
              {{ collect_store.address.house }}
              {{ typeof collect_store.address.flat !== 'undefined' && collect_store.address.flat !== '' ? `/ ${collect_store.address.flat}` : '' }}
            </div>
            <div>{{ collect_store.address.postcode }} {{ collect_store.address.city }}</div>
          </div>
        </section>
        <span class="om-vertical-space"></span>
        <section class="om-section">
          <h3 class="om-subheading">
            {{ $tr('Historia zamówienia:', 'Order') }}
          </h3>
          <ul class="om-summary">
            <li class="flex">
              <div class="om-summary__lab">{{ $tr('Data złożenia zamówienia:', 'Order') }}</div>
              <div class="om-summary__val">{{ $moment(order.date).format('DD.MM.YYYY HH:mm:SS') }}</div>
            </li>
            <li v-if="typeof order.date_store_delivery !== 'undefined'" class="flex">
              <div class="om-summary__lab">{{ $tr('Data przyjęcia zamówienia przez sklep stacjonarny:', 'Order') }}</div>
              <div class="om-summary__val">{{ $moment(order.date_store_delivery).format('DD.MM.YYYY HH:mm:SS') }}</div>
            </li>
            <li v-if="order.collected" class="flex">
              <div class="om-summary__lab">{{ $tr('Data odbioru zamówienia przez klienta:', 'Order') }}</div>
              <div class="om-summary__val">{{ $moment(order.date_collect).format('DD.MM.YYYY HH:mm:SS') }}</div>
            </li>
          </ul>
        </section>
      </div>
      <div v-else-if="isReturn()">
        <section class="om-section">
          <h3 class="om-subheading">
            {{ $tr('Podsumowanie zwrotu:', 'Order') }}
          </h3>
          <ul class="om-summary">
            <li class="flex">
              <div class="om-summary__lab">{{ $tr('Ilość zwróconych produktów:', 'Order') }}</div>
              <div class="om-summary__val">{{ returnSummary.quantity }}</div>
            </li>
            <li class="flex">
              <div class="om-summary__lab">{{ $tr('Wartość zwróconych produktów:', 'Order') }}</div>
              <div class="om-summary__val">{{ $helper.displayPrice(returnSummary.value, returnSummary.currency) }}</div>
            </li>
          </ul>
        </section>
        <section class="om-section">
          <h3 class="om-subheading">
            {{ $tr('Zwrot zrealizowany:', 'Order') }} &nbsp; &nbsp; &nbsp; <radio :disabled="return_completed" variant="check" :items="[{name: 'Zrealizowany', value: 1}]" :initial-value="order.confirmed" v-on:change="confirmReturn"></radio>
          </h3>
        </section>
      </div>
      <span class="om-vertical-space"></span>
    </div>
    <div v-else-if="notFound">
      {{ $tr('Brak szczegółów zamówienia', 'Order') }}
    </div>
    <div v-else>
    </div>
  </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'

  export default {
    components: {Paginator},
    name: 'order-for-central',
    data () {
      return {
        editFlags: {
          account_number: false
        },
        entityName: 'order',
        order: null,
        collect_store: null,
        return_store: null,
        notFound: false,
        states: null,
        choosedState: null,
        returnProd: {},
        returnProducts: {},
        message: '',
        return_completed: false
      }
    },
    mounted () {
      if (typeof this.$route.params.reference !== 'undefined') {
        if (this.isReturn()) {
          this.entityName = 'return'
        }
        this.$http.get(this.$router.options.getApiRoute(this.entityName, {reference: this.$route.params.reference})).then((resp) => {
          if (resp.ok && typeof resp.body[0] !== 'undefined') {
            console.log(resp.body[0])
            this.order = resp.body[0]
            if (this.isCollect()) {
              this.getStoreInfo(this.order.store_collect.code)
            }
            if (this.order.confirmed) {
              this.return_completed = true
            }
          }
        },
        (resp) => {
          console.log(resp.body)
          this.notFound = true
        })
      }

      /* status dropdown */
      this.states = [
        {name: this.$tr('Gotowe do odbioru', 'Order'), value: 'ready_to_collect'},
        {name: this.$tr('Odebrane', 'Order'), value: 'collected'}
        /* {name: this.$tr('Nieodebrane', 'Order'), value: 24} */
      ]
      // actions
    },
    methods: {
      changeChoosedState (val, key) {
        this.choosedState = val
      },
      pushOrderState () {
        if (!this.choosedState) {
          this.$alertify.notify(this.$tr('Wybierz status do aktualizacji', 'Order'), 'warning', 3)
          return false
        }
        this.$http.post(this.$router.options.getApiRoute('order', {reference: this.$route.params.reference}), {
          state: this.choosedState
        }).then((resp) => {
          if (resp.body.success) {
            this.$alertify.notify(this.$tr('Zaktualizowano status zamówienia', 'Order'), 'success', 3)
            this.$router.push({name: 'OrderList'})
          }
        },
        (resp) => {
          console.log('fail:')
          console.log(resp)
        })
      },
      getStoreInfo (code) {
        this.$http.get(this.$router.options.getApiRoute('shop-settings', {code: code}))
          .then((resp) => {
            if (typeof resp.body[0] !== 'undefined') {
              console.log(resp.body[0])
              if (this.isCollect()) {
                this.collect_store = resp.body[0]
              } else if (this.isReturn()) {
                this.return_store = resp.body[0]
              }
            }
          },
          (resp) => {
            console.log(resp.body)
          })
      },
      pushReturn () {
        this.$http.post(this.$router.options.getApiRoute('order-return', {reference: this.$route.params.reference}), {
          products: this.returnProducts,
          summary: this.returnSummary,
          message: this.message
        }).then((resp) => {
          console.log(resp.body)
          if (resp.body.success) {
            this.$router.push({name: 'OrderList'})
          }
        },
        (resp) => {
          console.log('fail:')
          console.log(resp)
          this.$helper.stdErrors(resp)
        })
      },
      updateCustomer (obj) {
        this.$http.post(this.$router.options.getApiRoute('customer', {id_customer: this.order.id_customer}), obj)
        .then((resp) => {
          if (resp.ok) {
            this.$alertify.notify(this.$tr('Uaktualniono pomyślnie', 'Order'), 'success', 3)
            this.editFlags.account_number = false
          }
        },
        (resp) => {
          this.$helper.stdErrors(resp)
        })
      },
      confirmReturn (val) {
        if (!val) {
          return false
        }
        this.$http.post(this.$router.options.getApiRoute('confirm-return', {reference: this.$route.params.reference}), {
          products: this.returnProducts,
          summary: this.returnSummary,
          message: this.message
        }).then((resp) => {
          console.log(resp)
          if (resp.ok) {
            this.return_completed = true
            this.$alertify.notify(this.$tr('Zamówienie zrealizowane', 'Order'), 'success', 3)
          }
        },
        (resp) => {
          this.$helper.stdErrors(resp)
        })
      },
      orderReturnModify (event, product) {
        console.log(product)
        let val = Number(event.target.value)
        if (isNaN(val) && event.target.value !== '') {
          event.target.value = 0
          val = 0
        }
        if (val > product.quantity) {
          event.target.value = product.quantity
          val = product.quantity
        }
        this.modifyReturnModify(val, product)
        event.target.value = val
      },
      modifyReturnModify (val, product) {
        if (val === 0) {
          delete this.returnProd[product.reference]
        } else {
          this.returnProd[product.reference] = {
            name: product.name,
            quantity: val,
            price: product.price,
            currency: product.currency
          }
        }
        this.returnProducts = {}
        this.returnProducts = this.returnProd
      },
      isCollect () {
        return this.$route.name === 'Collect'
      },
      isReturn () {
        return this.$route.name === 'Return'
      }
    },
    computed: {
      returnSummary () {
        let sum = 0
        let qty = 0
        let currency = ''
        for (let prod in this.order.products) {
          console.log(prod)
          sum += this.order.products[prod].price * this.order.products[prod].quantity
          qty += this.order.products[prod].quantity
          currency = this.order.products[prod].currency
        }
        return {
          value: sum.toFixed(2),
          currency: currency,
          quantity: qty
        }
      },
      isDispatch () {
        return this.$store.state.role === 'dispatch'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../../assets/scss/settings";
  @import "../../assets/scss/utilities";

  .om-order{
    &__lab{
      text-align: right;
      display: inline-block;
      width: 185px;
      padding-right: 45px;
      max-width: 50%;
      color: $omni-color-order-lab;
      font-family: $omni-font-custom;
      font-size: 16px;
      font-weight: 600;
      font-variant: small-caps;
    }
    &__general{
      list-style: none;
      margin: 50px 0 9px;
      padding: 0;
      li{
        line-height: 20px;
        color: $omni-color-table;
        font-size: 15px;
        font-weight: 700;
        padding: 0 0 8px;
      }
    }
    .om-table{
      th{
        color: $omni-color-table-head;
        background-color: transparent;
        border-bottom: 1px solid $omni-color-table-head;
        &:first-of-type{
          text-transform: uppercase;
        }
      }
      td{
        &.om{
          color: $omni-color-dark;
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          text-transform: uppercase;
        }
        &.product{

        }
      }
      tr:nth-of-type(2n+1) td {
        background-color: transparent;
      }
    }
  }

  .om-slash{
    text-align: center;
    width: 20px;
    display: inline-block;
  }

  .om-input--qty{
    width: 43px;
    height: 40px;
    border: 1px solid #c3c3c3;
    background-color: #ffffff;
    line-height: 38px;
    text-align: center;
    &:focus{
      outline: none;
      box-shadow: none;
    }
  }

  .om-products{
    margin: 60px 0 20px;
    padding: 15px 36px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    background-color: #eff3f6;
    &__medium{
      color: $omni-color-dark;
      font-family: $omni-font-family;
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      margin: 0 0 3px;
      padding: 0;
    }
    &__small{
      color: $omni-color-dark;
      font-family: $omni-font-family;
      font-size: 13px;
      font-weight: 300;
      line-height: 18px;
      margin: 0;
      padding: 0;
    }
    &__desc{
      padding-left: 11px;
    }
    &__image{
      width: 74px;
    }
  }

  .om-dropdown__title{
    padding: 0 25px 0 0;
    color: $omni-color-dark;
    font-family: $omni-font-family;
    font-size: 11px;
    font-weight: 400;
    line-height: 27px;
    text-transform: uppercase;
  }

  .om-btn--update{
    margin: 30px 0 15px;
    width: 326px;
    max-width: 100%;
  }
  .om-attributes{
    list-style: none;
    padding: 0;
    margin: 0;
    li{
      margin: 0;
      padding: 0;
    }
  }
  .om-col-8{
    width: 2px / 3px * 100%;
  }
  .om-col-4{
    width: 1px / 3px * 100%;
  }
  .om-col-4, .om-col-8{
    @include sm{
      width: 100%;
    }
  }
  .om-textarea{
    width: 100%;
    height: 69px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    border: 1px solid #c3c3c3;
    background-color: #ffffff;
    resize: vertical;
    padding: 5px 10px;
    font-family: $omni-font-family;
    font-size: 14px;
    font-weight: 300;
  }
  .om-summary{
    list-style: none;
    padding: 0;
    margin: 0;
    &__lab{
      width: 400px;
      max-width: 50%;
      padding-right: 25px;
      color: #69727e;
      font-family: $omni-font-custom;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      font-variant: small-caps;
      text-align: right;
    }
    &__val{
      color: $omni-color-table;
      font-family: $omni-font-family;
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
      max-width: calc(100% - 224px);
    }
    li{
      padding: 0 0 8px;
      margin: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// OrderForCentral.vue?613c6086